// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer___n5AH","lastFooter":"Footer_lastFooter__1fIFM"};